import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { home } from "@paths";
import { useCheckEstimateEditorAccess, useWorkspaceWebsocket } from "@hooks";
import {
  EstimateStructureProvider,
  EstimateEditorSettingsProvider,
  EditorContainer,
  EditorContent,
  useEstimateEditorStore,
  useHistoryManagerKeybinds,
  useNavigationKeybinds,
} from "@tools";
import { Alert } from "@components";
import { useEffect } from "react";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { SNACKBAR_ESTIMATE_READONLY } from "@utils";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

export const TemplateEditorView = observer(() => {
  const {t} = useTranslation();
  const editorStore = useEstimateEditorStore();
  const socket = useWorkspaceWebsocket();
  const navigate = useNavigate();
  
  const { isRemoved, currentEstimateStructure } = editorStore;
  
  useHistoryManagerKeybinds(currentEstimateStructure);
  useNavigationKeybinds(currentEstimateStructure);
  
  const {
    hasEditorPrivileges,
    hasSellerPrivileges,
  } = useCheckEstimateEditorAccess();
  
  useEffect(() => {
    if (!hasEditorPrivileges)
      enqueueSnackbar(t("alerts.editor.readonly_info.template"), {
        variant: "info",
        key: SNACKBAR_ESTIMATE_READONLY,
        persist: true,
        preventDuplicate: true,
        action: (snackbarId) => (
          <IconButton
            size="small"
            className="ml-2"
            color="inherit"
            onClick={() => closeSnackbar(snackbarId)}
          >
            <Close />
          </IconButton>
        )
      });
    
  }, [hasEditorPrivileges]);
  
  return (
    <EstimateStructureProvider value={currentEstimateStructure}>
      <EstimateEditorSettingsProvider
        hasEditorPrivileges={ hasEditorPrivileges && socket?.connectionOnline }
        hasSellerPrivileges={ hasSellerPrivileges }
        noTurningOff={ !socket?.connectionOnline || !hasEditorPrivileges }
        noCommenting={ !socket?.connectionOnline || !hasEditorPrivileges }
        // hasEditorPrivileges={socket?.connectionOnline}
        // hasSellerPrivileges
        allowInteractions
        isTemplate
        // estimateIdentifier={templateId}
      >
        <EditorContainer showUserMovement>
          <EditorContent useTemplateToolbar />
        </EditorContainer>
      </EstimateEditorSettingsProvider>
      {
        isRemoved &&
        <Alert
          isOpen
          title={t("alerts.editor.template_removed")}
          acceptText={t("alerts.editor.close_editor")}
          onAccept={() => navigate(home)}
        />
      }
    </EstimateStructureProvider>
  );
});